import Page from './page';

// Page already has a jsdoc where it is defined
// eslint-disable-next-line @repo/internal/react/require-jsdoc
export default Page;
export { default as Grid } from './grid-wrapper';
export { default as GridColumn } from './grid-column';